import classNames from './GoogleClassesResultModal.module.scss';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

interface GoogleClassesResultModalProps {
  show: boolean;
  sync?: boolean;
  deleteClasses?: boolean;
  studentsInAnotherGroup?: boolean;
  students?: { email: string; groupId: string | null }[];
  onSubmit: () => void;
}

const GoogleClassesResultModal = ({
  show,
  sync = false,
  deleteClasses = false,
  studentsInAnotherGroup = false,
  students = [],
  onSubmit,
}: GoogleClassesResultModalProps) => {
  const { t } = useTranslation();

  const getTitle = () => {
    if (studentsInAnotherGroup) return t('googleStudentsAlreadyInOtherGroups');
    if (deleteClasses) return t('classesDeleted');
    if (sync) return t('googleDataSynced');
    return t('googleDataAdded');
  };

  const getDescription = () => {
    if (studentsInAnotherGroup)
      return (
        <ul>
          {[...new Set(students.map(student => student.email))].map(email => (
            <li key={email}>{email}</li>
          ))}
        </ul>
      );
    if (deleteClasses) return t('classesDeletedDescription');
    if (sync) return t('googleDataSyncedDescription');
    return t('googleDataAddedDescription');
  };

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classnames(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classnames(classNames.modal, `fade-${state}`)}>
                <h2
                  className={classnames(
                    studentsInAnotherGroup ? classNames.studentsInAnotherGroup : null
                  )}
                >
                  {getTitle()}
                </h2>
                <span
                  className={classnames(
                    classNames.description,
                    studentsInAnotherGroup ? classNames.studentsInAnotherGroup : null
                  )}
                >
                  {getDescription()}{' '}
                </span>
                <TheButton
                  className={classNames.closeBtn}
                  text={sync || studentsInAnotherGroup ? t('ok') : t('done')}
                  shouldRecolor={false}
                  emitOnClick={onSubmit}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default GoogleClassesResultModal;
